import * as React from "react";

import { Page, Pages } from "../Page";

interface IProps {
  currentPage: Page;
  page: Page;

  onClick: (selected: Page) => void;
}
export class PageLink extends React.Component<IProps> {
  public render() {
    const { page, currentPage, onClick } = this.props;
    return (
      <div
        key={page}
        className={"topnav-item" + (currentPage === page ? " active" : "")}
      >
        <a
          className="topnav-link"
          // tslint:disable-next-line jsx-no-lambda
          onClick={() => onClick(page as Page)}
          href="#"
        >
          {Pages[page].name}
        </a>
      </div>
    );
  }
}

export default PageLink;



// WEBPACK FOOTER //
// ./src/components/PageLink.tsx